import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Spinner from "../../components/spinner";
import { axiosApi } from "../../../services/axios_api";
import PaginatorComponent from "../../components/paginator";
import useDebounce from "../../components/hooks/useDebounce";
import { toast } from "react-toastify";
import moment from "moment";
import Dots from "../../../../assets/assests/detail.png";
import { Button } from "primereact/button";
import Details from "./details_machine";
import { Dialog } from "primereact/dialog";
import { exportToExcel, renderTextWithTooltip } from "../../components/helper";
import { Tag } from "primereact/tag";

export default function MachineMonitor({
  globalFilter,
  exportCSV,
  fromDate,
  toDate,
}) {
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  const [rowselect, setRowselect] = useState(null);
  const [showdetail, setShowdetail] = useState(false);
  const debouncedSearch = useDebounce(globalFilter, 500);

  const getMachineMonitorData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/kiosks/monitor/get-all-paginated`,
        {
          params: {
            pageNumber,
            pageSize,
            searchTerm: debouncedSearch || "",
            fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
          },
        }
      );
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };
  const actionTemplate = (rowData) => {
    return (
      <div className="action-buttons">
       
        <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button>

      </div>
    );
  };

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getMachineMonitorData(pageNumber, rows);
  };

  useEffect(() => {
    getMachineMonitorData();
  }, [debouncedSearch, fromDate, toDate]);

  const columnsData = [
    // {
    //   field: "kioskId",
    //   header: "Kiosk ID",
    //   body: (rowData) => rowData.kioskId || "--",
    //   frozen: true,
    // },
    {
      field: "kioskName",
      header: "Kiosk Name",
      frozen: true,
      body: (rowData) => renderTextWithTooltip(rowData, "kioskName", "bottom"),
    },
    {
      field: "cashAcceptor",
      header: "Cash Acceptor",
      body: (rowData) => (
        <span
          style={{
            fontWeight: "600",
            color: rowData.cashAcceptor === "Online" ? "green" : "red",
          }}
        >
          {rowData.cashAcceptor ?? "--"}
        </span>
      ),
    },
    {
      field: "cardDispenser",
      header: "Card Dispenser",
      body: (rowData) => (
        <span
          style={{
            fontWeight: "600",
            color: rowData.cardDispenser === "Online" ? "green" : "red",
          }}
        >
          {rowData.cardDispenser ?? "--"}
        </span>
      ),
    },
    {
      field: "receiptPrinter",
      header: "Receipt Printer",
      body: (rowData) => (
        <span
          style={{
            fontWeight: "600",
            color: rowData.receiptPrinter === "Online" ? "green" : "red",
          }}
        >
          {rowData.receiptPrinter ?? "--"}
        </span>
      ),
    },
    // {
    //   field: "networkStatus",
    //   header: "Network Status",
    //   body: (rowData) => (
    //     <span
    //       style={{
    //         fontWeight: "600",
    //         color: rowData.networkStatus === "Online" ? "green" : "red",
    //       }}
    //     >
    //       {rowData.networkStatus ?? "--"}
    //     </span>
    //   ),
    // },

    {
      field: "totalOperations",
      header: "Total Operation",
      body: (rowData) => rowData.totalOperations || "--",
    },
    {
      field: "successOperations",
      header: "Success Operation",
      body: (rowData) => rowData.successOperations || "--",
    },
    {
      field: "failedOperations",
      header: "Failed Operation",
      body: (rowData) => rowData.failedOperations || "--",
    },
    // {
    //   field: "createdDate",
    //   header: "created Date",
    //   body: (rowData) =>
    //     rowData.createdDate
    //       ? moment(rowData.createdDate).format("YYYY-MM-DD HH:mm:ss")
    //       : "--",
    // },
    {
      field: "overallHealth",
      header: "Overall Health",
      body: (rowData) => (
        <Tag
          className={
            rowData.overallHealth === "Healthy"
              ? "custom-success-tag"
              : "custom-danger-tag"
          }
          value={rowData.overallHealth || "--"}
        />
      ),
    },
    {
      field: "lastUpdated",
      header: "Last Update",
      body: (rowData) =>
        rowData.lastUpdated
          ? moment(rowData.lastUpdated).format("YYYY-MM-DD HH:mm:ss")
          : "--",
    },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];
 
  const exportCSVHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(`/Portal/kiosks/monitor/get-all`);
      exportToExcel(response.data.body, columnsData, "MachineMonitorData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (exportCSV) {
      exportCSV.current = exportCSVHandler;
    }
  }, []);
  const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  }
  return (
    <>
     <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="Machine Monitor Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
}
